import React, { useEffect, useRef, useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Doughnut } from 'react-chartjs-2';

// Registramos los elementos necesarios de Chart.js
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const DoughnutProyecto = ({ proyectosAgrupados }) => {
  const containerRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 1. Extraemos las etiquetas y los datos de tu reduce
  const labels = proyectosAgrupados.map(p => p.nomEstado);
  const dataValues = proyectosAgrupados.map(p => p.cantidad);

  // 2. Definimos colores fijos basados en el estado para consistencia visual
  const mapColores = {
    'Finalizado': '#10b981', // Rojo
    'En Proceso': '#3b82f6', // Verde
    'Pendiente': '#DBD838',  // Ámbar
    'Rechazado': '#ef4444',  // Naranja
  };

  const backgroundColor = labels.map(label => mapColores[label] || '#94a3b8');

  const data = {
    labels: labels,
    datasets: [
      {
        label: 'Cantidad de Proyectos',
        data: dataValues,
        backgroundColor: backgroundColor,
        borderColor: backgroundColor,
        borderWidth: 1,
        cutout: '70%', // Esto define el grosor del donut
        hoverOffset: 10,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        color: '#fff',
        font: {
          weight: 'bold',
          size: isMobile ? 10 : 12
        },
        formatter: (value, context) => {
          const total = context.dataset.data.reduce((a, b) => a + b, 0);
          const percentage = ((value / total) * 100).toFixed(1);
          return `${percentage}%`;
        },
        anchor: 'center',
        align: 'center'
      },
      legend: {
        position: isMobile ? 'bottom' : 'bottom',
        labels: {
          color: '#fff',
          padding: isMobile ? 10 : 20,
          font: { 
            size: isMobile ? 11 : 14,
            weight: 'normal'
          },
          boxWidth: isMobile ? 10 : 15
        }
      },
      tooltip: {
        callbacks: {
          // Valor agregado: Mostrar porcentaje además de la cantidad
          label: (context) => {
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const value = context.raw;
            const percentage = ((value / total) * 100).toFixed(1);
            return ` ${value} proyectos (${percentage}%)`;
          }
        }
      }
    }
  };

  return (
    <div 
      ref={containerRef}
      style={{ 
        width: '100%',
        height: 'auto',
        minHeight: '350px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        padding: isMobile ? '10px' : '0'
      }}
    >
      <div style={{ position: 'relative', width: '100%', height: '350px' }}>
        <Doughnut data={data} options={options} />
        
        {/* Valor Agregado: El Total en el centro mediante posicionamiento absoluto */}
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
          pointerEvents: 'none',
          zIndex: 10
        }}>
          <h3 style={{ 
            fontSize: isMobile ? '1.5rem' : '2rem', 
            margin: 0, 
            color: '#fff',
            fontWeight: 'bold'
          }}>
            {dataValues.reduce((a, b) => a + b, 0)}
          </h3>
          <p style={{ 
            margin: '5px 0 0 0', 
            color: '#94a3b8', 
            fontSize: isMobile ? '0.75rem' : '0.9rem',
            fontWeight: '500'
          }}>
            TOTAL
          </p>
        </div>
      </div>
    </div>
  );
};

export default DoughnutProyecto;